import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/serviceBookingsSagas";
import { selectChartControlsDisabled } from "../redux/serviceBookingsSelectors";

export function UpdateBtns() {
  const dispatch = useDispatch();
  const filtersDirty = useSelector((state) => state.serviceBookings.filtersDirty);
  const chartControlsDisabled = useSelector(selectChartControlsDisabled);

  return filtersDirty ? (
    <div className="action-buttons">
      <button
        className="submit"
        disabled={chartControlsDisabled}
        onClick={() => dispatch(actionCreators.updateData())}
      >
        Update
      </button>
      <button className="submit reset" onClick={() => dispatch(actionCreators.resetData())}>
        Reset
      </button>
    </div>
  ) : null;
}
